// redux/slices/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { dashboardReducer } from "../Reducer/dashboardReducer";

const initialState = {
    allPendingLeaves: [],
    pagination: {
        currentPage: 1,
        pageSize: 10,
        totalData: 0,
        totalPages: 1
    },
    loading: false,
    error: null
};

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setDashboardCurrentPage: (state, action) => {
            state.pagination.currentPage = action.payload;
        },
    },
    extraReducers: (builder) => {
        dashboardReducer(builder);
    }

});

export const { setDashboardCurrentPage } = dashboardSlice.actions;
export default dashboardSlice.reducer;
